import React from 'react'
import { useDispatch } from 'react-redux'
import { setKambiClientVisibility } from '@core/Areas/KambiClient/Store'
import { toggleKambiVisibility } from '@core/Areas/KambiClient/helpers/visibility'

export const useToggleKambiClientVisibility = (shouldHideKambiClient: boolean): void => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (shouldHideKambiClient) {
      dispatch(setKambiClientVisibility(false))
      toggleKambiVisibility(false)
    } else {
      dispatch(setKambiClientVisibility(true))
      toggleKambiVisibility(true)
    }

    return () => {
      dispatch(setKambiClientVisibility(false))
      toggleKambiVisibility(false)
    }
  }, [shouldHideKambiClient, dispatch])
}
